<template>
  <div class="flex gap-1 items-center">
    <PSelectableTag
      :model-value="letterFileTagIds.includes(tag.id)"
      @update:model-value="update(tag, $event)"
      :disabled="readonly"
      v-for="tag in tags"
      :key="tag.id"
    >
      {{ tag.name }}
    </PSelectableTag>

    <PTooltip class="ml-1" :offset="5" :delay="500" label="Ajouter un nouveau badge">
      <PreferencesForm defaultTab="badges" buttonLabel="Ajouter" />
    </PTooltip>
  </div>
</template>

<script setup lang="ts">
import { PSelectableTag, PTooltip } from "@pasta/box-v2";
import { uniq, uniqBy } from "lodash";
import { computed } from "vue";
import { type LetterFileDto } from "../dto/letter-file.dto";
import { type LetterFileTagDto } from "../dto/letter-file-tag.dto";
import { useUserPreferencesStore } from "../stores/user-preferences.store";
import PreferencesForm from "./PreferencesForm.vue";

interface Props {
  letterFile: LetterFileDto;
  readonly: boolean;
}
const props = defineProps<Props>();
const emit = defineEmits<{ (e: "input", value: number[]): void }>();

const userPreferencesStore = useUserPreferencesStore();
const letterFileTagIds = computed(() => (props.letterFile.tags || []).map(tag => tag.id));

const tags = computed(() => {
  return uniqBy([...(props.letterFile.tags || []), ...(userPreferencesStore.tags || [])], "name");
});

function update(tag: LetterFileTagDto, value: boolean) {
  if (value) {
    emit("input", uniq([...letterFileTagIds.value, tag.id]));
  } else {
    emit(
      "input",
      letterFileTagIds.value.filter(id => id !== tag.id)
    );
  }
}
</script>
